<template>
  <div>
    <HeadersDetalhesResumo
      :apelido="imovel.apelido"
      :proprietario="imovel.proprietario"
      :tipo="imovel.tipo"
      :savoynet="imovel.savoynet"
    >
    </HeadersDetalhesResumo>
    <v-layout row wrap align-center class="secondary white--text detalhes-header">
      <v-flex xs2>
        <v-container fluid class="py-2">
          <v-layout row wrap>
            <v-flex xs12 class="text-xs-left">
              <v-btn icon :to="({ name: 'ImoveisDetalhesResumo', params: { id: $route.params.id } })" class="ma-0 white--text">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs8>
        <v-container fluid class="py-2">
          <v-layout row wrap>
            <v-flex xs12>
              <span class="subtitulo">Pagamentos</span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-container fluid class="pa-0">
      <v-layout row wrap>
        <v-flex xs12 class="pagamentos-content py-4" v-if="canViewPagamentos">
          <PagamentosLista :imovelId="$route.params.id" />
        </v-flex>
        <v-flex xs12 class="pagamentos-content py-5 text-xs-center" v-else>
          <v-icon size="42" color="grey lighten-1">lock</v-icon>
          <div class="subheading grey--text text--darken-1 mt-3">Você não possui permissão para visualizar pagamentos.</div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import HeadersDetalhesResumo from '../Headers/HeadersDetalhesResumo'
  import PagamentosLista from './PagamentosLista'

  export default {
    components: {
      HeadersDetalhesResumo,
      PagamentosLista
    },
    computed: {
      imovel () {
        return this.$store.getters['imoveis/detalhes']
      },
      canViewPagamentos () {
        return this.$hasGranularPermission('pagamentos', 'view')
      }
    }
  }
</script>

<style scoped>
  .pagamentos-content {
    padding-left: 24px;
    padding-right: 24px;
  }

  @media (max-width: 599px) {
    .pagamentos-content {
      padding-left: 14px;
      padding-right: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// PagamentosMain.vue?8df17076